window.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("header-nav")) {
    class HeaderNav extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.initEvent();
        this.initFirstActive();
        this.initEventListeners();
        this.initKeyboardScope();
      }

      initEvent() {
        const btn = this.querySelectorAll(".header-link-btn");
        if (!btn) return;
        const headerWrapper = this.closest(".header-wrapper");
        for (let btn_item of btn) {
          btn_item.addEventListener("click", (e) => {
            window.open(btn_item.dataset.href, "_blank");
          });
        }

        for (const parent of this.querySelectorAll(".site-nav--has-dropdown")) {
          const $parents = $(parent);
          $parents.on("mouseenter touchstart focusin", this.onHoverParentNav);
          parent.addEventListener("focusin", () => {
            parent.classList.add("nav-hover");
            if (headerWrapper) {
              headerWrapper.classList.add("keyboard-nav-hover");
            }
            if (this.updateKeyboardScope) {
              this.updateKeyboardScope();
            }
          });
          parent.addEventListener("focusout", () => {
            setTimeout(() => {
              if (!parent.contains(document.activeElement)) {
                parent.classList.remove("nav-hover");
              }
              if (
                headerWrapper &&
                (!document.activeElement || !document.activeElement.closest(".site-nav--has-dropdown"))
              ) {
                headerWrapper.classList.remove("keyboard-nav-hover");
              }
              if (this.updateKeyboardScope) {
                this.updateKeyboardScope();
              }
            }, 10);
          });
        }
      }

      onHoverParentNav(e) {
        const target = e.currentTarget;
        if (target) {
          // Only init swipers in the currently active tab panel (+ always-visible ones)
          const activePanel = target.querySelector(".right_nav-content > .item.active");
          const scope = activePanel || target;
          const navSwiperElements = scope.querySelectorAll("header-nav-swiper");
          for (const navSwiper of navSwiperElements) {
            if (typeof navSwiper.init === "function") navSwiper.init();
            if (navSwiper.swiper) navSwiper.swiper.update();
          }
        }
      }

      initFirstActive() {
        const left_container_list = this.querySelectorAll(".site-nav__dropdown-container-new .left_nav-content");
        for (let item of left_container_list) {
          const obj = item.querySelector(".menu-item.active");
          if (!obj) continue;
          const dropdownRoot = item.closest(".site-nav__dropdown-container-new") || item.parentElement;
          const activeLeftText = dropdownRoot.querySelector(".right_nav-active-text .active-left_text");
          const activeLeftSubtitle = dropdownRoot.querySelector(".right_nav-active-text .active-left_subtitle");
          if (!activeLeftText || !activeLeftSubtitle) continue;

          const name = obj.getAttribute("data-class_name") || "";
          const customName = obj.querySelector(".header-title-custom")
            ? obj.querySelector(".header-title-custom").innerText
            : "";
          const subtitle = obj.querySelector(".header-title-content")
            ? obj.querySelector(".header-title-content").innerText
            : "";
          activeLeftText.innerText = customName || name;
          activeLeftSubtitle.innerText = subtitle;
          this.setCollectoinUrl(obj);
        }
      }
      initEventListeners() {
        const menuItems = this.querySelectorAll(".site-nav__dropdown-container-new .left_nav-content .menu-item");
        const handleMenuItemActivate = function (menuItem) {
          if (!menuItem || !menuItem.hasAttribute("data-index")) return;

          const index = parseInt(menuItem.getAttribute("data-index"), 10) - 1;
          const name = menuItem.getAttribute("data-name");
          const class_name = menuItem.getAttribute("data-class_name");
          const customName = menuItem.querySelector(".header-title-custom")
            ? menuItem.querySelector(".header-title-custom").innerText
            : "";
          const headerTitleContent = menuItem.querySelector(".header-title-content");
          const subtitle = headerTitleContent ? headerTitleContent.textContent : "";

          const imageStatus = menuItem.closest(".site-nav__image-status");
          if (!imageStatus) return;

          const localMenuItems = imageStatus.querySelectorAll(
            ".site-nav__dropdown-container-new .left_nav-content .menu-item",
          );
          localMenuItems.forEach((el) => el.classList.remove("active"));
          menuItem.classList.add("active");
          this.setCollectoinUrl(menuItem);

          const rightNavItems = Array.from(imageStatus.querySelectorAll(".right_nav-content > .item"));
          rightNavItems.forEach((item, i) => {
            if (i === index) {
              item.classList.add("active");
              item.querySelectorAll("header-nav-swiper").forEach((navSwiper) => {
                if (typeof navSwiper.init === "function") navSwiper.init();
                if (navSwiper.swiper) navSwiper.swiper.update();
              });
            } else {
              item.classList.remove("active");
            }
          });

          const activeLeftText = imageStatus.querySelector(".right_nav-active-text .active-left_text");
          if (activeLeftText) {
            activeLeftText.textContent = customName || class_name;
          }
          const activeLeftSubtitle = imageStatus.querySelector(".right_nav-active-text .active-left_subtitle");
          if (activeLeftSubtitle) {
            activeLeftSubtitle.textContent = subtitle;
          }

          const rightSidebarLink = imageStatus.querySelector(".right_nav-sidebar .shop-all-link a");
          if (rightSidebarLink) {
            const activeItem = imageStatus.querySelector(`.right_nav-content > .item[data-index="${index + 1}"]`);
            if (activeItem) {
              const specificUrl = activeItem.getAttribute("data-shop-all-url");
              const specificText = activeItem.getAttribute("data-shop-all-text");
              const defaultUrl = rightSidebarLink.getAttribute("data-default-href");

              const finalUrl = specificUrl || defaultUrl;

              if (finalUrl) {
                rightSidebarLink.setAttribute("href", finalUrl);
                rightSidebarLink.parentElement.style.display = "flex";
              } else {
                rightSidebarLink.parentElement.style.display = "none";
              }
            }
          }

          const leftNavContent = menuItem.closest(".left_nav-content");
          if (leftNavContent) {
            const menuDownLists = leftNavContent.querySelectorAll(
              `.header_nav-link-box .menu-down_list[data-name="${name}"]`,
            );
            menuDownLists.forEach((list) => {
              list.classList.add("active");
              const listSiblings = Array.from(list.parentElement.children).filter((el) => el !== list);
              listSiblings.forEach((el) => el.classList.remove("active"));
            });
          }
          if (this.updateKeyboardScope) {
            this.updateKeyboardScope();
          }
        };

        menuItems.forEach((menuItem) => {
          menuItem.addEventListener("mouseenter", () => {
            handleMenuItemActivate.call(this, menuItem);
          });
          menuItem.addEventListener("keydown", (event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              handleMenuItemActivate.call(this, menuItem);
            }
          });
        });

        if (window.innerWidth > 1000) {
          const headerSection = this.closest('[data-section-type="header-section"]');
          if (headerSection) {
            headerSection.addEventListener("mouseleave", function () {
              const allElements = this.querySelectorAll("*");
              allElements.forEach((el) => el.blur());
            });
          }
        }

        const languageBox = document.querySelectorAll(".choose-language-box");
        languageBox.forEach((item) => {
          item.addEventListener("click", function () {
            const isExpanded = this.getAttribute("aria-expanded") === "true";

            this.setAttribute("aria-expanded", !isExpanded);

            document.querySelector(".pc-language-box .website_change_wrapper .item")?.click();
          });
        });
      }

      initKeyboardScope() {
        const focusableSelector = "a[href], button, input, select, textarea, [tabindex], [data-managed-tabindex]";
        const managedAttr = "data-managed-tabindex";
        const headerSection = this.closest('[data-section-type="header-section"]');
        const navDrawer = document.getElementById("NavDrawer");
        const isVisibleForTab = (element) => {
          if (element.closest("[hidden]") || element.closest('[aria-hidden="true"]')) {
            return false;
          }
          if (element.closest("#NavDrawer") && !document.body.classList.contains("js-drawer-open-left")) {
            return false;
          }
          const rightNavPanel = element.closest(".right_nav-content .item");
          if (
            rightNavPanel &&
            rightNavPanel.parentElement &&
            rightNavPanel.parentElement.classList.contains("right_nav-content") &&
            !rightNavPanel.classList.contains("active")
          ) {
            return false;
          }
          const style = window.getComputedStyle(element);
          if (style.display === "none" || style.visibility === "hidden") {
            return false;
          }
          return element.getClientRects().length > 0;
        };
        const updateFocusableScope = () => {
          const focusables = new Set();
          if (headerSection) {
            headerSection.querySelectorAll(focusableSelector).forEach((element) => focusables.add(element));
          }
          if (navDrawer) {
            navDrawer.querySelectorAll(focusableSelector).forEach((element) => focusables.add(element));
          }
          focusables.forEach((element) => {
            const shouldDisable = !isVisibleForTab(element);
            if (shouldDisable) {
              if (!element.hasAttribute(managedAttr)) {
                const originalTabindex = element.getAttribute("tabindex");
                element.setAttribute(managedAttr, originalTabindex === null ? "" : originalTabindex);
              }
              element.setAttribute("tabindex", "-1");
              return;
            }
            if (element.hasAttribute(managedAttr)) {
              const originalTabindex = element.getAttribute(managedAttr);
              if (originalTabindex === "") {
                element.removeAttribute("tabindex");
              } else {
                element.setAttribute("tabindex", originalTabindex);
              }
              element.removeAttribute(managedAttr);
            }
          });
        };
        this.updateKeyboardScope = updateFocusableScope;
        updateFocusableScope();
        window.addEventListener("resize", updateFocusableScope);
        document.addEventListener("click", () => {
          setTimeout(updateFocusableScope, 0);
        });
        const bodyObserver = new MutationObserver(updateFocusableScope);
        bodyObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }

      setCollectoinUrl(activeMenuItemDom) {
        if (!activeMenuItemDom) return;
        const dropdown = activeMenuItemDom.closest(".site-nav__dropdown");
        if (!dropdown) return;
        const seeAll = dropdown?.querySelector(".right_nav-active-text .active-link a");
        const activeLink = activeMenuItemDom.getAttribute("data-link");
        const hasValidActiveLink = this.isValidCollectionLink(activeLink);
        this.updateCollectionLinkByActiveItem(seeAll, activeLink);

        const existingViewAll = dropdown.querySelector(".header-bottom-buttons .view-all a");
        if (existingViewAll) {
          this.updateCollectionLinkByActiveItem(existingViewAll, activeLink);
        } else if (hasValidActiveLink) {
          const fallbackHref =
            (seeAll && (seeAll.getAttribute("href") || seeAll.getAttribute("data-original-href"))) || "/";
          const viewAll = this.getOrCreateViewAllLink(dropdown, fallbackHref);
          const followActiveMenu = seeAll?.getAttribute("data-follow-active-menu");
          if (followActiveMenu !== null && followActiveMenu !== undefined) {
            viewAll.setAttribute("data-follow-active-menu", followActiveMenu);
          }
          this.updateCollectionLinkByActiveItem(viewAll, activeLink);
        }

        if (!hasValidActiveLink) {
          this.removeDynamicViewAllStructures(dropdown);
        }
      }

      updateCollectionLinkByActiveItem(linkDom, activeLink) {
        if (!linkDom) return;
        if (!linkDom.hasAttribute("data-original-href")) {
          const initialHref = linkDom.getAttribute("href") || "";
          linkDom.setAttribute("data-original-href", initialHref);
        }
        const originalHref = linkDom.getAttribute("data-original-href") || "";
        const followActiveMenu = linkDom.getAttribute("data-follow-active-menu");
        if (followActiveMenu === "false") return;
        if (followActiveMenu !== "true" && originalHref !== "/") return;
        if (activeLink && activeLink !== "/") {
          linkDom.setAttribute("href", activeLink);
        } else {
          if (originalHref) {
            linkDom.setAttribute("href", originalHref);
          } else {
            linkDom.removeAttribute("href");
          }
        }
      }

      isValidCollectionLink(link) {
        return !!(link && link !== "/");
      }

      getOrCreateViewAllLink(dropdown, fallbackHref = "/") {
        let bottomButtons = dropdown.querySelector(".header-bottom-buttons");
        if (!bottomButtons) {
          bottomButtons = document.createElement("div");
          bottomButtons.className = "header-bottom-buttons";
          bottomButtons.setAttribute("data-dynamic-created", "true");
          dropdown.appendChild(bottomButtons);
        }

        let wrapper = bottomButtons.querySelector(".header-bottom-buttons-wrapper");
        if (!wrapper) {
          wrapper = document.createElement("div");
          wrapper.className = "header-bottom-buttons-wrapper";
          while (bottomButtons.firstChild) {
            wrapper.appendChild(bottomButtons.firstChild);
          }
          bottomButtons.appendChild(wrapper);
        }

        let viewAllButton = wrapper.querySelector(".header-bottom-button.view-all");
        if (!viewAllButton) {
          viewAllButton = document.createElement("div");
          viewAllButton.className = "header-bottom-button view-all";
          viewAllButton.setAttribute("data-dynamic-created", "true");

          const viewAllLink = document.createElement("a");
          viewAllLink.setAttribute("href", fallbackHref || "/");
          viewAllLink.setAttribute("target", "_blank");
          const maskId = `path-view-all-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
          viewAllLink.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
              <mask id="${maskId}" fill="white">
                <rect width="9.47368" height="20" rx="1"></rect>
              </mask>
              <rect width="9.47368" height="20" rx="1" stroke="black" stroke-width="4" mask="url(#${maskId})"></rect>
              <path d="M11.5789 2.10547H19.9999" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M11.5789 9.47266H19.9999" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M11.5789 16.8438H19.9999" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <div class="common-pc--hide">View All</div>
            <div class="common-small--hide">View All</div>
          `;
          viewAllButton.appendChild(viewAllLink);

          const compareButton = wrapper.querySelector(".header-bottom-button.compare-model");
          if (compareButton) {
            wrapper.insertBefore(viewAllButton, compareButton);
          } else {
            wrapper.appendChild(viewAllButton);
          }
        }

        this.syncBottomButtonSeparator(wrapper);
        return wrapper.querySelector(".header-bottom-button.view-all a");
      }

      removeDynamicViewAllStructures(dropdown) {
        if (!dropdown) return;
        const bottomButtons = dropdown.querySelector(".header-bottom-buttons");
        if (!bottomButtons) return;

        if (bottomButtons.getAttribute("data-dynamic-created") === "true") {
          bottomButtons.remove();
          return;
        }

        const wrapper = bottomButtons.querySelector(".header-bottom-buttons-wrapper");
        if (!wrapper) return;

        const dynamicViewAll = wrapper.querySelector('.header-bottom-button.view-all[data-dynamic-created="true"]');
        if (dynamicViewAll) {
          dynamicViewAll.remove();
        }

        this.syncBottomButtonSeparator(wrapper);
      }

      syncBottomButtonSeparator(wrapper) {
        if (!wrapper) return;
        const viewAllButton = wrapper.querySelector(".header-bottom-button.view-all");
        const compareButton = wrapper.querySelector(".header-bottom-button.compare-model");
        let sep = wrapper.querySelector(".header-bottom-button-sep");

        if (viewAllButton && compareButton) {
          if (!sep) {
            sep = document.createElement("div");
            sep.className = "header-bottom-button-sep";
          }
          wrapper.insertBefore(sep, compareButton);
        } else if (sep) {
          sep.remove();
        }
      }
    }
    customElements.define("header-nav", HeaderNav);
  }
  if (!customElements.get("header-nav-swiper")) {
    class HeaderNavSwiper extends HTMLElement {
      isFirstInit = true;
      constructor() {
        super();
        this.swiper = null;
        this.variant_btn = this.querySelectorAll(".header_variants-container");
      }

      init() {
        if (!this.isFirstInit) return;
        this.initSwiper();
        this.resizeEvent();
        this.initBtnEvent();
        this.initMbEvent();
        this.isFirstInit = false;
      }
      initBtnEvent() {
        for (let item of this.variant_btn) {
          let item_span = item.querySelectorAll("span");
          for (let item_child of item_span) {
            item_child.addEventListener("click", () => {
              const img_url = item_child.getAttribute("data-img_url");
              for (const child of item_child.parentElement.children) {
                child.classList.remove("active");
              }
              item_child.classList.add("active");
              item_child.parentElement.parentElement.parentElement.querySelector(".site-nav__dropdown-linka img").src =
                img_url;
            });
          }
        }
      }
      initSwiper() {
        if (!!this.swiper) return;
        const swiperContainer = this.querySelector(".swiper-container");
        const scrollbar = this.querySelector(".swiper-scrollbar");
        let allowTouch = this.getAttribute("data-allow-touch") == "false" ? false : true;
        if (!swiperContainer) return;
        this.swiper = new Swiper(swiperContainer, {
          slidesPerView: "auto",
          allowTouchMove: allowTouch,
          observer: true,
          observeParents: true,
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
          navigation: {
            nextEl: this.querySelector(".swiper-button-prev"),
            prevEl: this.querySelector(".swiper-button-next"),
          },
        });
      }

      resizeEvent() {
        if (window.innerWidth < 1300) {
          this.swiper ? (this.swiper.allowTouchMove = true) : null;
        }
        window.addEventListener("resize", () => {
          if (this.swiper) {
            this.swiper.update();
          }
        });
      }
      initMbEvent() {
        if (window.innerWidth <= 1100) {
          let btn_items = this.querySelectorAll(".mobile-nav__toggle-btn");
          for (let btn_i of btn_items) {
            btn_i.addEventListener("click", () => {
              this.initSwiper();
            });
          }
        }
      }
    }
    customElements.define("header-nav-swiper", HeaderNavSwiper);
  }
  if (!customElements.get("drawer-menu")) {
    class DrawerMenu extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.initEventListeners();
      }
      initEventListeners() {
        this.initFirstLevelAccordion();
        this.initRowExpandClicks();
      }
      getFirstLevelToggleButtons() {
        return this.querySelectorAll(
          ".mobile-nav > .mobile-nav__item > .first-level-menu .mobile-nav__toggle-btn"
        );
      }
      getExpandableRows() {
        return this.querySelectorAll(
          ".mobile-nav > .mobile-nav__item > .first-level-menu, .mobile-nav .second-level-menu"
        );
      }
      isExpandableRow(row) {
        if (!row) return false;
        if (row.querySelector(".mobile-nav__toggle-btn")) return true;
        const sublist = row.nextElementSibling;
        return !!(sublist && sublist.classList.contains("mobile-nav__sublist"));
      }
      setRowExpanded(row, expanded, animate = true) {
        if (!row) return;

        const button = row.querySelector(".mobile-nav__toggle-btn");
        const sublist = row.nextElementSibling;
        const item = row.parentElement;

        if (button) {
          button.setAttribute("aria-expanded", expanded ? "true" : "false");
        }
        row.classList.toggle("mobile-nav--expanded", expanded);
        if (item && item.classList.contains("mobile-nav__item")) {
          item.classList.toggle("mobile-nav--expanded", expanded);
        }

        if (!sublist || !sublist.classList.contains("mobile-nav__sublist")) return;

        if (window.jQuery) {
          const $sublist = $(sublist);
          if (!animate) {
            expanded ? $sublist.show() : $sublist.hide();
          } else {
            expanded ? $sublist.slideDown() : $sublist.slideUp();
          }
        } else {
          sublist.style.display = expanded ? "block" : "none";
        }
      }
      setFirstLevelExpanded(button, expanded, animate = true) {
        const hasSublist = button.closest(".mobile-nav__has-sublist");
        this.setRowExpanded(hasSublist, expanded, animate);
      }
      // 整行可点展开/收起（不局限于右侧按钮）
      initRowExpandClicks() {
        this.getExpandableRows().forEach((row) => {
          if (!this.isExpandableRow(row)) return;
          if (row.dataset.rowExpandBound === "true") return;
          row.dataset.rowExpandBound = "true";
          row.classList.add("mobile-nav__row--expandable");

          row.addEventListener("click", (e) => {
            // 链接跳转优先，不拦截 a 标签
            if (e.target.closest("a[href]")) return;
            // 点在右侧按钮上时交给 theme.js，避免重复 toggle
            if (e.target.closest(".mobile-nav__toggle-btn")) return;

            const button = row.querySelector(".mobile-nav__toggle-btn");
            if (button) {
              button.click();
              return;
            }

            // 无 toggle 按钮时（如二级 two-level 仅箭头）自行切换
            const willExpand = !row.classList.contains("mobile-nav--expanded");
            this.setRowExpanded(row, willExpand);
          });
        });
      }
      initFirstLevelAccordion() {
        const buttons = this.getFirstLevelToggleButtons();
        if (!buttons.length) return;

        buttons.forEach((button) => {
          button.addEventListener("click", () => {
            // Wait for theme.js toggle handler, then enforce accordion
            setTimeout(() => {
              const isExpanded = button.getAttribute("aria-expanded") === "true";
              const hasSublist = button.closest(".mobile-nav__has-sublist");
              const item = hasSublist && hasSublist.parentElement;

              if (item) {
                item.classList.toggle("mobile-nav--expanded", isExpanded);
              }

              if (!isExpanded) return;

              this.getFirstLevelToggleButtons().forEach((otherBtn) => {
                if (otherBtn === button) return;
                if (otherBtn.getAttribute("aria-expanded") === "true") {
                  this.setFirstLevelExpanded(otherBtn, false);
                }
              });
            }, 0);
          });
        });

        const expandFirst = () => {
          const firstBtn = this.getFirstLevelToggleButtons()[0];
          if (!firstBtn) return;

          this.getFirstLevelToggleButtons().forEach((btn) => {
            this.setFirstLevelExpanded(btn, false, false);
          });
          this.setFirstLevelExpanded(firstBtn, true, false);
        };

        // Run after theme.js initSideBarDropDowns (resets aria-expanded)
        if (window.jQuery) {
          $(() => setTimeout(expandFirst, 0));
        } else {
          setTimeout(expandFirst, 0);
        }
      }
    }
    customElements.define("drawer-menu", DrawerMenu);
  }
  if (!customElements.get("header-drawer-menu")) {
    class HeaderDrawerMenu extends HTMLElement {
      constructor() {
        super();
        this.swiper_list_arr = [];
        this.variant_btn = this.querySelectorAll(".header_variants-container");
        this.swiper_list = this.querySelectorAll(".swiper-container");
        this.mobile_nav__imglink = this.querySelectorAll(".mobile-nav__imglink");
      }
      connectedCallback() {
        this.initEventListeners();
        this.initBtnEvent();
      }
      initBtnEvent() {
        for (let item of this.variant_btn) {
          let item_span = item.querySelectorAll("span");
          for (let item_child of item_span) {
            item_child.addEventListener("click", () => {
              const img_url = item_child.getAttribute("data-img_url");
              for (const child of item_child.parentElement.children) {
                child.classList.remove("active");
              }
              item_child.classList.add("active");
              item_child.parentElement.parentElement.parentElement.querySelector(".site-nav__dropdown-linka img").src =
                img_url;
            });
          }
        }
      }
      initEventListeners() {
        for (let item of this.mobile_nav__imglink) {
          item.addEventListener("click", () => {
            let timer_id = setTimeout(() => {
              this.initSwiper();
              clearTimeout(timer_id);
            }, 100);
          });
        }
      }
      initSwiper() {
        if (this.swiper_list_arr.length > 0) return;
        for (let swiper_item of this.swiper_list) {
          const scrollbar = swiper_item.querySelector(".swiper-scrollbar");
          let swiper = new Swiper(swiper_item, {
            slidesPerView: "auto",
            scrollbar: {
              el: scrollbar,
              draggable: true,
            },
          });
          this.swiper_list_arr.push(swiper);
        }
      }
    }
    customElements.define("header-drawer-menu", HeaderDrawerMenu);
  }
  const headerSection = document.querySelector(
    '#shopify-section-header-new, [id^="shopify-section-sections--"][id$="__header-new"]',
  );
  if (headerSection) {
    const siteHeader = headerSection.querySelector(".site-header");
    const productTemplate = document.querySelector(".product-template-container");
    const isProductPage = document.body.classList.contains("template-product");
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollTicking = false;

    const updateHeaderOnScroll = () => {
      const scrollTop = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
      const isSticky = scrollTop > 40;
      const isScrollingDown = scrollTop > lastScrollTop;
      const headerHeight = headerSection.offsetHeight;
      const hasVisibleProductTemplate = productTemplate && productTemplate.offsetHeight > 0;
      const productContentPassed =
        hasVisibleProductTemplate && productTemplate.getBoundingClientRect().bottom <= 0;
      const shouldHide =
        isProductPage &&
        (hasVisibleProductTemplate
          ? productContentPassed
          : isScrollingDown && scrollTop > headerHeight * 2.3 - 50);

      headerSection.classList.toggle("header-section--sticky", isSticky);
      headerSection.classList.toggle("header-section--hidden", shouldHide);
      if (siteHeader) {
        siteHeader.classList.toggle("header--sticky", isSticky);
      }

      lastScrollTop = scrollTop;
      scrollTicking = false;
    };

    window.addEventListener(
      "scroll",
      () => {
        if (!scrollTicking) {
          window.requestAnimationFrame(updateHeaderOnScroll);
          scrollTicking = true;
        }
      },
      { passive: true },
    );

    updateHeaderOnScroll();
  }
});
